import React from 'react';
import { motion } from 'framer-motion';

export default function Contact() {
  return (
    <motion.section
      id="contact"
      className="section contact"
      initial={{ opacity: 0, y: 20 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      transition={{ duration: 0.6 }}
    >
      <h2 className="section-title">Contact</h2>
      <div className="contact-links">
        <a href="mailto:sreedeep200@gmail.com" className="contact-link">sreedeep200@gmail.com</a>
        <a href="https://www.linkedin.com/in/sreedeep-cv-b7a486202" target="_blank" rel="noopener noreferrer" className="contact-link">LinkedIn</a>
        <a href="https://github.com/rogueloop" target="_blank" rel="noopener noreferrer" className="contact-link">GitHub</a>
      </div>
      {/* <p className="contact-phone">8301985990</p> */}
    </motion.section>
  );
}
